import { addLocaleData } from 'react-intl';
import { SET_DEALER_LOCALE } from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.dealerLocale, action) {
  switch (action.type) {
    case SET_DEALER_LOCALE: {
      const { localeCode } = action.payload;
      const [languageCode, countryCode] = localeCode.split('_');
      addLocaleData(require(`react-intl/locale-data/${languageCode}`));
      return {
        locale: localeCode,
        countryCode,
        languageCode
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/dealerLocale/reducer.js